/** @file imageMethods: uploads a PNG to a puppet's image table (raw image/png body). */
import type { UploadedImage } from '../types/restAdded';
import type { ClientOptions } from './clientOptions';
import { fillPath } from './fillPath';
import { request } from './request';

/** The image member of the client. */
export type ImageMethods = {
  /** `POST /api/v1/puppets/{id}/images`; fill a slot with the returned id through `slot.fill`. */
  uploadImage: (puppetId: string, png: Uint8Array) => Promise<UploadedImage>;
};

/** The bytes on an `ArrayBuffer` (what fetch bodies take); a view on any other buffer is copied once. */
const onArrayBuffer = (png: Uint8Array): Uint8Array<ArrayBuffer> =>
  png.buffer instanceof ArrayBuffer ? (png as Uint8Array<ArrayBuffer>) : new Uint8Array(png);

/** Image calls over `opts`. */
export function imageMethods(opts: ClientOptions): ImageMethods {
  return {
    uploadImage: async (id, png) => (await request<UploadedImage>(opts, {
      method: 'POST', path: fillPath('/api/v1/puppets/{id}/images', { id }), bytes: onArrayBuffer(png), contentType: 'image/png', accept: 'json',
    })).value,
  };
}
